package com.wintermar.inspection.core.ui.component.datetime

import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.modal.ModalDialog
import com.wintermar.inspection.core.ui.component.modal.util.ModalAction
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.save
import org.jetbrains.compose.resources.stringResource

@Composable
fun DateTimePickerDialog(
    title: String,
    show: Boolean = false,
    dateIsoUtc0String: String = "",
    onDismiss: () -> Unit,
    onSave: (String) -> Unit
) {
    var selectedValue by remember { mutableStateOf(dateIsoUtc0String) }

    ModalDialog(
        show = show,
        title = title,
        onDismiss = onDismiss,
        action = ModalAction.default().copy(
            showAction = true,
            withBackgroundHeader = true,
            widthButtonBasedOnText = true,
            label = stringResource(Res.string.save),
            onClick = {
                onDismiss()
                onSave(selectedValue)
            }
        )
    ) {
        LazyColumn {
            item {
                DateTimePicker(
                    isoUtc0String = dateIsoUtc0String,
                    modifier = Modifier.animateItem(),
                    onValueChanged = {
                        selectedValue = it
                    }
                )
            }
        }
    }
}
